import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import Api from "../../../assets/js/utils/Api.js";
import axios from "axios";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import LoaderComponent from "../Loader.js";
import CustomInput from "../CustomInput/CustomInput.jsx";

import storageModalStyle from "../../../assets/jss/user/storageModalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const PurchaseTextractCreditsModal = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        // const { user } = this.store.getState();

        this.state = {
            packs: 1,
            rate: 0.04,
            loading: false,
            cancelToken: null,
        };
    }
    handleChange(event, name) {
        let value = event.target.value;
        
        this.setState({
            [name]: value
        });
    }
    onPayNow(){
        let packs = this.state.packs;
        
        const source = axios.CancelToken.source();
        this.setState({
            loading: true,
            cancelToken: source
        });
        const requestData = {
            packs: packs,
        };
        Api.addTextractPoints(requestData, source).then(data => {
            window.location.href = data.checkout_url;
        }).catch(err => {
            this.setState({
                loading: false,
            });
        });
        
    }
    render() {
        const { classes } = this.props;
        const { rate, loading } = this.state;
        let packs = this.state.packs;
        if(packs.length <= 0){
            packs = "0";
        }
        const cost = packs * rate;
        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="increaseStorageModal-modal-slide-title"
                aria-describedby="increaseStorageModal-modal-slide-description"
            >
                <DialogTitle
                    id="increaseStorageModal-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    >
                        <h4 className={classes.modalTitle}>Purchase Textract Credits</h4> 
                </DialogTitle>
                <DialogContent
                    id="increaseStorageModal-modal-slide-description"
                    className={classes.modalBody}
                >
                    <CustomInput 
                        formControlProps={{
                            fullWidth: true
                        }}
                        labelText="Number of Packs"
                        inputProps={{
                            name: "packs",
                            id: "input-packs",
                            className: classes.numberInput,
                            type: "number",
                            value: this.state.packs,
                            onChange: (e) => this.handleChange(e, "packs"),
                            inputProps: {
                                min: "1"
                            }
                        }}
                    />
                    <p>Estimated Cost: ${cost.toFixed(2)}</p>
                    <p>1 pack = 1 text credit, 1 form credit, 1 table credit, 1 receipt credit</p>
                </DialogContent>
                <DialogActions className={classes.modalFooter +" " +classes.justifyContentCenter}>
                    {
                        loading ?
                            <LoaderComponent color="custom" align="center" />
                        :
                        <>
                            <Button color="white" onClick={() => this.props.onClose()}>
                                Cancel
                            </Button>
                            <Button color="custom" onClick={() => this.onPayNow()} disabled={cost <= 0}>
                                Pay Now
                            </Button>
                        </>
                    }
                    
                </DialogActions>
            </Dialog>
        )
    }
}

PurchaseTextractCreditsModal.defaultProps = {
    open: false,
    loadingMessage: "",
    successMessage: "",
    saving: false,
    errorMessage: null
}
PurchaseTextractCreditsModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    loadingMessage: PropTypes.string,
    saving: PropTypes.bool,
    errorMessage: PropTypes.string
}
export default withStyles(storageModalStyle)(PurchaseTextractCreditsModal);